import { tags } from '@/constants/Tags';
import filterThemes from './filterThemes';

export default function filterThemesWithOtherTags({
  searchText,
  showFavourites,
  favouriteThemes,
  themes,
  filteredThemes,
  language,
  selectedTagId,
  activityType,
}) {
  if (!searchText || !selectedTagId) return [];

  return filterThemes({
    searchText,
    showFavourites,
    favouriteThemes,
    themes: themes.filter(
      (theme) =>
        !filteredThemes.some((filteredTheme) => filteredTheme.id == theme.id)
    ),
    language,
    tagIds: tags.filter((tag) => tag.id != selectedTagId).map((tag) => tag.id),
    activityType,
  });
}
